import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  DataGridGroup,
  useResponsiveParams,
  Text,
  Button,
  NotificationList,
} from 'quanta-ui';
import { useQuery } from '@apollo/client';
import {
  DOWNLOAD_FIRE_PROPOSAL_PDF,
  GET_BUY_FIRE_POLICY_VAR_DETAILS,
  GET_BUY_FIRE_UPLOAD_POLICY_VAR_DETAILS,
  GET_DATE_TIME,
  LOB_PRODUCT_LIST,
  PROPOSAL_PAYMENT_TYPE_LIST,
} from '../queries';
// import Loading from '../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
// import Parse from '../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
import {
  faDownload,
  faExternalLinkAlt,
  faSpinner,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalViewBreakupFire from '../../../../common/view-breakup/fire/view-breakup';
import { ModalViewBreakupFire } from 'quanta-flows/modules/common/viewBreakUp';
// import useMutationQuery from '../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';

export default function FireProposalSummary({
  lobCode,
  lobName,
  productName,
  productCode,
  planName,
  planCode,
  proposalNumber,
}) {
  const [alerts, setAlerts] = useState([]);
  const mutateQuery = useMutationQuery();
  const fetchQuery = useFetchQuery();
  const [showViewBreakup, setShowViewBreakup] = useState(false);

  const [loadingDownload, setLoadingDownload] = useState(false);
  const [mounted, setMounted] = useState(false);
  const repeatForMobile = 2,
    repeatForDesktop = 1,
    repeatForIPad = 4;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
    for_iPad: repeatForIPad,
  });

  let screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
    for_iPad: 'iPad',
  });

  const {
    loading: loadingLobList,
    error: errorLobList,
    data: dataLobList,
  } = useQuery(LOB_PRODUCT_LIST, {
    fetchPolicy: 'cache-first',
  });

  const {
    loading: list_loading,
    error: error_list,
    data: ListDetails,
  } = useQuery(PROPOSAL_PAYMENT_TYPE_LIST, {
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    let isMounted = true;
    if (ListDetails && dataLobList && !mounted) {
      setMounted(true);
    }
    return () => {
      isMounted = false;
    };
  }, [mounted, dataLobList, ListDetails]);

  const {
    loading: loadingBuyFirePolicy,
    error: errorBuyFirePolicy,
    data: dataBuyFirePolicy,
  } = useQuery(GET_BUY_FIRE_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
  });
  const {
    loading: loadingUploadDocsVar,
    error: errorUploadDocsVar,
    data: dataUploadDocsVar,
  } = useQuery(GET_BUY_FIRE_UPLOAD_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
  });

  if (
    loadingLobList ||
    list_loading ||
    loadingBuyFirePolicy ||
    loadingUploadDocsVar
  ) {
    return <Loading />;
  }
  if (
    errorLobList ||
    error_list ||
    errorBuyFirePolicy ||
    errorUploadDocsVar
  ) {
    return <Error />;
  }

  if (dataBuyFirePolicy) {
    var { buyFirePolicy } = dataBuyFirePolicy;
    var { quoteData, premiumData } = buyFirePolicy;
  }
  if (quoteData) {
    var tabDetails = quoteData?.tabDetails;
    var customerTabDetails = tabDetails?.customerTabDetails;
    var policyTypeDetails = customerTabDetails?.policyTypeDetails;
    var tenure = policyTypeDetails?.tenure;
  }
  //const { fireQuoteUploadDocs } = dataUploadDocsVar;
  const  fireQuoteUploadDocs  = null;
  if (ListDetails) {
    var { ProposalPaymentTypeList } = ListDetails;
  }

  const getBase64Var = (buyFirePolicy, getDateTimeData) => {
    return {
      input: {
        intermediary: {
          intermediaryCode: buyFirePolicy?.intermediary?.code,
          locationCode: buyFirePolicy?.intermediary?.branchOfficeCode,
          fieldUserCode: buyFirePolicy?.intermediary?.fieldUserCode,
        },
        lob: lobCode,
        product: productCode,
        proposalNumber:buyFirePolicy?.proposalNumber,
        customer: {
          id: buyFirePolicy?.proposerDetails?.id,
          customerType: buyFirePolicy?.proposerDetails?.customerType,
          isThinCustomer: false,
          title: buyFirePolicy?.proposerDetails?.title,
          firstName: buyFirePolicy?.proposerDetails?.firstName,
          middleName: buyFirePolicy?.proposerDetails?.middleName,
          lastName: buyFirePolicy?.proposerDetails?.lastName,
          gender: buyFirePolicy?.proposerDetails?.gender,
          proposerDOB: buyFirePolicy?.proposerDetails?.proposerDOB,
          orgName: buyFirePolicy?.proposerDetails?.orgName,
          orgType: buyFirePolicy?.proposerDetails?.orgType,
          contactName: buyFirePolicy?.proposerDetails?.contactName,
          regNumber: buyFirePolicy?.proposerDetails?.regNumber,
          tanNumber: buyFirePolicy?.proposerDetails?.tanNumber,
          gstNumber: buyFirePolicy?.proposerDetails?.gstNumber,
          idProofType: buyFirePolicy?.proposerDetails?.idProofType,
          idProofNumber:
            buyFirePolicy?.proposerDetails?.idProofNumber,
          panNumber: buyFirePolicy?.proposerDetails?.panNumber,
          maritalStatus:
            buyFirePolicy?.proposerDetails?.maritalStatus,
          occupation: buyFirePolicy?.proposerDetails?.occupation,
          nationality: buyFirePolicy?.proposerDetails?.nationality,
          permAddressLine1:
            buyFirePolicy?.proposerDetails?.permAddressLine1,
          permAddressLine2:
            buyFirePolicy?.proposerDetails?.permAddressLine2,
          permAddressLine3:
            buyFirePolicy?.proposerDetails?.permAddressLine3,
          permLandmark: buyFirePolicy?.proposerDetails?.permLandmark,
          permPincode: buyFirePolicy?.proposerDetails?.permPincode,
          permCityTownVillage:
            buyFirePolicy?.proposerDetails?.permCityTownVillage,
          permDistrict: buyFirePolicy?.proposerDetails?.permDistrict,
          permState: buyFirePolicy?.proposerDetails?.permState,
          permCommAddressYN: buyFirePolicy?.proposerDetails
            ?.permCommAddressYN
            ? true
            : false,
          commAddressLine1:
            buyFirePolicy?.proposerDetails?.commAddressLine1,
          commAddressLine2:
            buyFirePolicy?.proposerDetails?.commAddressLine2,
          commAddressLine3:
            buyFirePolicy?.proposerDetails?.commAddressLine3,
          commLandmark: buyFirePolicy?.proposerDetails?.commLandmark,
          commPincode: buyFirePolicy?.proposerDetails?.commPincode,
          commCityTownVillage:
            buyFirePolicy?.proposerDetails?.commCityTownVillage,
          commDistrict: buyFirePolicy?.proposerDetails?.commDistrict,
          commState: buyFirePolicy?.proposerDetails?.commState,
          phoneNo: buyFirePolicy?.proposerDetails?.phoneNo,
          mobileNo: buyFirePolicy?.proposerDetails?.mobileNo,
          emailID: buyFirePolicy?.proposerDetails?.emailID,
          faxNo: buyFirePolicy?.proposerDetails?.faxNo,
          altPhoneNo: buyFirePolicy?.proposerDetails?.altPhoneNo,
          altMobileNo: buyFirePolicy?.proposerDetails?.altMobileNo,
          ifscCode: buyFirePolicy?.proposerDetailsMeta?.ifscCode,
          bankName: buyFirePolicy?.proposerDetailsMeta?.bankName,
          branchName: buyFirePolicy?.proposerDetailsMeta?.branchName,
          bankAcno: buyFirePolicy?.proposerDetailsMeta?.bankAcno,
          accountHolderName:
            buyFirePolicy?.proposerDetailsMeta?.accountHolderName,
          micrCode: buyFirePolicy?.proposerDetailsMeta?.micrCode,
          employeeNumber: buyFirePolicy?.proposerDetails
            ?.employeeNumber
            ? buyFirePolicy?.proposerDetails?.employeeNumber
            : '',

          agentID: buyFirePolicy?.proposerDetails?.agentID
            ? buyFirePolicy?.proposerDetails?.agentID
            : '',
        },
        businessOfInsured: buyFirePolicy?.businessOfInsured,
        anyPrevClaimsExp: buyFirePolicy?.anyPrevClaimsExp,
        prevClaimExpDesc: buyFirePolicy?.prevClaimExpDesc,
        isKutchaConstruct: buyFirePolicy?.isKutchaConstruct,
        policyType: buyFirePolicy?.policyType,
        quoteNumber: buyFirePolicy?.quoteNumber,
        tenure: buyFirePolicy?.tenure,
        policyStartDate: buyFirePolicy?.policyStartDate,
        riskLocations:
          buyFirePolicy?.policyTypeValue
            ?.toString()
            ?.toLowerCase() === 'floater'
            ? {
                quoteNumber: buyFirePolicy?.quoteNumber,
                riskLocationID:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.riskLocationID,
                occupancyCodeValue: {
                  code:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.code,
                  value:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.value,
                  occupancySection:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.occupancySection,
                  occupancyRate:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.occupancyRate,
                  riskCode:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskCode,
                  rateCode:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.rateCode,
                  riskGrade:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskGrade,
                  riskGradeDefinition:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskGradeDefinition,
                  riskPreference:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.riskPreference,
                  gicClass:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.gicClass,
                  stfiRate:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.stfiRate,
                  rsmdRate:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType?.occupancy
                      ?.rsmdRate,
                },
                riskLocAddress: {
                  addressLine1: '',
                  addressLine2: '',
                  addressLine3: '',
                  landmark: '',
                  pinCode: '',
                  state: '',
                  city: '',
                  district: '',
                  zone: '',
                  eqZone: '',
                  locationCode: '',
                  isSamePremises: false,
                  allIndiaBasisDesc: '',
                },

                floaterLocations: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.floaterType?.floaterLocations?.map(
                  (fire) => {
                    return {
                      addressLine1: fire?.addressLine1,
                      addressLine2: fire?.addressLine2
                        ? fire?.addressLine2
                        : '',
                      addressLine3: fire?.addressLine3
                        ? fire?.addressLine3
                        : '',
                      landmark: '',
                      pinCode: fire?.pinCode ? fire?.pinCode : '',
                      state: fire?.state ? fire?.state : '',
                      city: fire?.city ? fire?.city : '',
                      district: fire?.district ? fire?.district : '',
                      zone: fire?.zone ? fire?.zone : '',
                      eqZone: fire?.eqZone ? fire?.eqZone : '',
                      locationCode: fire?.locationCode
                        ? fire?.locationCode
                        : '',
                      isSamePremises:
                        fire?.isSamePremises === true ? true : false,
                      allIndiaBasisDesc: fire?.isSamePremises
                        ? fire?.isSamePremises
                        : '',
                    };
                  },
                ),

                buildingSI: '',
                plantMachinerySI: '',
                furnitureFixtureSI: '',
                rawMaterialSI: '',
                otherContentsSI: '',
                stocksSI:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.riskSumInsured?.stocksSI,

                stocksInProcessSI:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.riskSumInsured?.stocksInProcessSI,

                fireExtinguishApplisDtls: buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.floaterType?.fireExtinguisherAppliancesDetails?.map(
                  (fire) => {
                    return {
                      applianceCode: fire?.value,
                      isSelected: fire?.selected,
                    };
                  },
                ),
                constructionClass:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.otherDetails?.classOfConstruction,

                waterbodyDistance:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.otherDetails?.distanceFromWaterbody,

                securityProvisions:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.otherDetails?.securityProvisions,

                loadingPct:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.loadingAndDiscount?.loadingPercentage,
                discountPct:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.loadingAndDiscount?.discountPercentage,
                prevClaimExpDesc:
                  buyFirePolicy?.quoteData?.tabDetails
                    ?.riskLocationTabDetails?.floaterType
                    ?.previousClaimDetails?.claimExperience,

                premium: {
                  locNetPremium:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.locationNetPremium,
                  locGST:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.locationGST,
                  locTotalPremium:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.locationTotalPremium,
                  stampDuty:
                    buyFirePolicy?.quoteData?.tabDetails
                      ?.riskLocationTabDetails?.floaterType
                      ?.locationPremium?.stampDuty,
                },
              }
            : buyFirePolicy?.policyTypeValue
                ?.toString()
                ?.toLowerCase() === 'non floater'
            ? buyFirePolicy?.quoteData?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.map(
                (fireData) => {
                  return {
                    quoteNumber: buyFirePolicy?.quoteNumber,
                    riskLocationID: fireData?.riskLocationID,

                    occupancyCodeValue: {
                      code: fireData?.occupancy?.code,
                      value: fireData?.occupancy?.value,
                      occupancySection:
                        fireData?.occupancy?.occupancySection,
                      occupancyRate:
                        fireData?.occupancy?.occupancyRate,
                      riskCode: fireData?.occupancy?.riskCode,
                      rateCode: fireData?.occupancy?.rateCode,
                      riskGrade: fireData?.occupancy?.riskGrade,
                      riskGradeDefinition:
                        fireData?.occupancy?.riskGradeDefinition,
                      riskPreference:
                        fireData?.occupancy?.riskPreference,
                      gicClass: fireData?.occupancy?.gicClass,
                      stfiRate: fireData?.occupancy?.stfiRate,
                      rsmdRate: fireData?.occupancy?.rsmdRate,
                    },
                    riskLocAddress: {
                      addressLine1:
                        fireData?.addressDetails?.addressLine1,
                      addressLine2: fireData?.addressDetails
                        ?.addressLine2
                        ? fireData?.addressDetails?.addressLine2
                        : '',
                      addressLine3: fireData?.addressDetails
                        ?.addressLine3
                        ? fireData?.addressDetails?.addressLine3
                        : '',
                      landmark: fireData?.addressDetails?.landmark
                        ? fireData?.addressDetails?.landmark
                        : '',
                      pinCode: fireData?.addressDetails?.pinCode
                        ? fireData?.addressDetails?.pinCode
                        : '',
                      state: fireData?.addressDetails?.state
                        ? fireData?.addressDetails?.state
                        : '',
                      city: fireData?.addressDetails?.city
                        ? fireData?.addressDetails?.city
                        : '',
                      district: fireData?.addressDetails?.district
                        ? fireData?.addressDetails?.district
                        : '',
                      zone: fireData?.addressDetails?.zone
                        ? fireData?.addressDetails?.zone
                        : '',
                      eqZone: fireData?.addressDetails?.eqZone
                        ? fireData?.addressDetails?.eqZone
                        : '',
                      locationCode: fireData?.addressDetails
                        ?.locationCode
                        ? fireData?.addressDetails?.locationCode
                        : '',
                      isSamePremises:
                        fireData?.addressDetails?.isSamePremise ===
                        true
                          ? true
                          : false,
                      allIndiaBasisDesc: '',
                    },
                    buildingSI: fireData?.riskSumInsured?.buildingSI
                      ? fireData?.riskSumInsured?.buildingSI
                      : '',
                    plantMachinerySI: fireData?.riskSumInsured
                      ?.plantAndMachinerySI
                      ? fireData?.riskSumInsured?.plantAndMachinerySI
                      : '',
                    furnitureFixtureSI: fireData?.riskSumInsured
                      ?.furnitureFixtureAndFittingsSI
                      ? fireData?.riskSumInsured
                          ?.furnitureFixtureAndFittingsSI
                      : '',
                    rawMaterialSI: fireData?.riskSumInsured
                      ?.rawMaterialSI
                      ? fireData?.riskSumInsured?.rawMaterialSI
                      : '',
                    otherContentsSI: fireData?.riskSumInsured
                      ?.otherContentsSI
                      ? fireData?.riskSumInsured?.otherContentsSI
                      : '',
                    stocksSI: fireData?.riskSumInsured?.stocksSI,

                    stocksInProcessSI:
                      fireData?.riskSumInsured?.stocksInProcessSI,

                    fireExtinguishApplisDtls: fireData?.fireExtinguisherAppliancesDetails?.map(
                      (fire) => {
                        return {
                          applianceCode: fire?.value,
                          isSelected: fire?.selected,
                        };
                      },
                    ),
                    constructionClass:
                      fireData?.otherDetails?.classOfConstruction,

                    waterbodyDistance:
                      fireData?.otherDetails?.distanceFromWaterbody,

                    securityProvisions:
                      fireData?.otherDetails?.securityProvisions,

                    loadingPct:
                      fireData?.loadingAndDiscount?.loadingPercentage,
                    discountPct:
                      fireData?.loadingAndDiscount
                        ?.discountPercentage,
                    prevClaimExpDesc:
                      fireData?.previousClaimDetails?.claimExperience,

                    premium: {
                      locNetPremium:
                        fireData?.locationPremium?.locationNetPremium,
                      locGST: fireData?.locationPremium?.locationGST,
                      locTotalPremium:
                        fireData?.locationPremium
                          ?.locationTotalPremium,
                      stampDuty: fireData?.locationPremium?.stampDuty,
                    },
                  };
                },
              )
            : {},
        clauses: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.clauses?.defaultClauses,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.clauses?.userDefinedClauses
            ?.filter((clause) => clause !== '')
            ?.map((clause) => {
              return clause;
            }),
        },
        warranties: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.warranties?.defaultWarranties,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.warranties?.userDefinedWarranties
            ?.filter((warranty) => warranty !== '')
            ?.map((warranty) => {
              return warranty;
            }),
        },
        conditions: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.conditions?.defaultConditions,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.conditions?.userDefinedConditions
            ?.filter((condition) => condition !== '')
            ?.map((condition) => {
              return condition;
            }),
        },
        exclusions: {
          default:
            buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails
              ?.exclusions?.defaultExclusions,
          userDefined: buyFirePolicy?.quoteData?.tabDetails?.additionalTabDetails?.exclusions?.userDefinedExclusions
            ?.filter((exclusion) => exclusion !== '')
            ?.map((exclusion) => {
              return exclusion;
            }),
        },
        finalisedPremium: {
          locNetPremium:
            buyFirePolicy?.quoteData?.finalisedPremium
              ?.locationNetPremium,
          locGST:
            buyFirePolicy?.quoteData?.finalisedPremium?.locationGST,
          locTotalPremium:
            buyFirePolicy?.quoteData?.finalisedPremium
              ?.locationTotalPremium,
          stampDuty:
            buyFirePolicy?.quoteData?.finalisedPremium?.stampDuty,
        },
        financierDtls: {
          financerName: buyFirePolicy?.financierDetails?.financerName,
          financerAddress:
            buyFirePolicy?.financierDetails?.financerAddress,
          financerAgreementType:
            buyFirePolicy?.financierDetails?.financerAgreementType,
          loanAccountNumber:
            buyFirePolicy?.financierDetails?.loanAccountNumber,
          FileNumber: buyFirePolicy?.financierDetails?.fileNumber,
        },

        uploadDocuments:
          fireQuoteUploadDocs?.documentDetails &&
          fireQuoteUploadDocs?.documentDetails?.length > 0
            ? fireQuoteUploadDocs?.documentDetails?.map(
                (uploadDet) => {
                  return {
                    documentType: {
                      code: uploadDet?.documentName,
                      value: uploadDet?.documentNameValue,
                    },
                    documentName:
                      uploadDet?.documentFileNameWithExtension,
                    documentSize: uploadDet?.documentSizeinKB,
                    base64EncodedDoc: uploadDet?.documentBase64String,
                  };
                },
              )
            : [],
      },
    };
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
          `${returnType}`
        ]
      : '';
  };

  if (dataLobList) {
    var { lobProductList } = dataLobList;
  }

  let proposalSummaryDataDesktopView = [
    {
      grid_data: [
        buyFirePolicy?.quoteNumber
          ? {
              label: (
                <div className="flex justify-start mt-2 mb-0.5">
                  <Text
                    type="label"
                    className="flex justify-end items-end h-full"
                  >
                    Quotation Number
                  </Text>
                  <Text className="text-secondary flex items-center">
                    <FontAwesomeIcon
                      icon={faExternalLinkAlt}
                      className="cursor-pointer ml-2 text-xs"
                      onClick={(_) =>
                        window.open(
                          `/uiquote/saved/${lobCode}/${
                            lobProductList?.find(
                              (lpl) =>
                                lpl?.lob_code?.toLowerCase() ===
                                lobCode?.toLowerCase(),
                            )?.lob_name
                          }/${productCode}/${productName}/${
                            buyFirePolicy?.quoteNumber
                          }`,
                        )
                      }
                    />
                  </Text>
                </div>
              ),
              colSpan: repeat,
              text: (
                <Link
                  to={`/uiquote/saved/${lobCode}/${
                    lobProductList?.find(
                      (lpl) =>
                        lpl?.lob_code?.toLowerCase() ===
                        lobCode?.toLowerCase(),
                    )?.lob_name
                  }/${productCode}/${productName}/${
                    buyFirePolicy?.quoteNumber
                  }`}
                >
                  <Text className="text-secondary underline">
                    {buyFirePolicy?.quoteNumber}
                  </Text>
                </Link>
              ),
            }
          : null,
        buyFirePolicy?.proposalNumber
          ? {
              label: (
                <span className="text-primary">Proposal Number</span>
              ),
              colSpan: repeat,
              text: <Text>{buyFirePolicy?.proposalNumber}</Text>,
            }
          : null,
        buyFirePolicy?.proposalStatus
          ? {
              label: (
                <span className="text-primary">Proposal Status</span>
              ),
              text: <Text>{buyFirePolicy?.proposalStatus}</Text>,
              colSpan: repeat,
            }
          : null,
        tenure?.value
          ? {
              label: <span className="text-primary">Tenure</span>,
              text: (
                <span>
                  {parseInt(tenure?.value) === 1 ? (
                    <Text>{tenure?.value} Year</Text>
                  ) : (
                    <Text>{tenure?.value} Years</Text>
                  )}
                </span>
              ),
              colSpan: repeat,
            }
          : null,
        premiumData
          ? {
              label: (
                <span className="text-primary">
                Total Premium (inclusive of all taxes)
                </span>
              ),
              colSpan: repeat,
              text: (
                <div className="flex justify-start space-x-2 mt-1">
                  <span>
                    <Text
                      type="larger"
                      severity="info"
                      className="mt-0.5"
                    >
                      {CurrencyFormater(premiumData?.totalPremium)}{' '}
                    </Text>
                  </span>
                  <span className="mt-2.5">
                    <Text
                      severity="action"
                      type="label"
                      className="quanta_link cursor-pointer mt-1"
                      onClick={(_) => {
                        setShowViewBreakup(true);
                      }}
                    >
                      View Breakup
                    </Text>
                  </span>
                </div>
              ),
            }
          : null,
        {
          text: (
            <span className="flex flex-col items-end justify-end py-3 w-full h-full">
              <Button
                flat={true}
                type={'button'}
                disabled={
                  !buyFirePolicy?.proposalNumber.length > 0 ||
                  loadingDownload
                }
                size="medium"
                className="w-full"
                onClick={async (_) => {
                  try {
                    setAlerts([]);
                    setLoadingDownload(true);
                    let getDateTime = fetchQuery({
                      query: GET_DATE_TIME,
                    });
                    let { data: getDateTimeData } = await getDateTime;
                    let fireProposalPdfVariables = getBase64Var(
                      buyFirePolicy,
                      getDateTimeData,
                    );

                    let proposalPDFBase64String = mutateQuery({
                      mutation: DOWNLOAD_FIRE_PROPOSAL_PDF,
                      variables: fireProposalPdfVariables,
                    });

                    let {
                      data: dataBase64String,
                    } = await proposalPDFBase64String;

                    const {
                      firedownloadProposalForm,
                    } = dataBase64String;
                    const {
                      base64Pdf: downloadBase64String,
                    } = firedownloadProposalForm;
                    setLoadingDownload(false);

                    let byteCharacters = atob(
                      downloadBase64String.toString(),
                    );
                    let byteNumbers = new Array(
                      byteCharacters?.length,
                    );
                    for (let i = 0; i < byteCharacters?.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], {
                      type: 'application/pdf;base64',
                    });
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                  } catch (error) {
                    setAlerts([
                      {
                        id: Date.now(),
                        content: (
                          <div className="flex flex-col w-full h-full">
                            <Text type="normal">{error.message}</Text>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                    setLoadingDownload(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={loadingDownload ? faSpinner : faDownload}
                  className="mr-4"
                  spin={loadingDownload}
                  size="lg"
                />
                {loadingDownload
                  ? 'Downloading...'
                  : 'Download Proposal Form'}
              </Button>
            </span>
          ),
          colSpan: repeat,
        },
      ].filter((d) => d),
    },
  ];

  let proposalSummaryDataMobileView = [
    {
      grid_data: [
        {
          label: (
            <span className="text-primary">Proposal Number</span>
          ),
          text: (
            <div className="flex flex-col">
              {buyFirePolicy?.proposalNumber ? (
                <>
                  <Text>{buyFirePolicy?.proposalNumber}</Text>
                </>
              ) : (
                <Text severity="neutral-darker" className="mt-0.5">
                  Not Captured
                </Text>
              )}
            </div>
          ),
        },
        premiumData
          ? {
              label: (
                <span className="text-primary">Annual Premium</span>
              ),
              text: (
                <div className="flex justify-start space-x-2 mt-1 items-center">
                  <span>
                    <Text
                      type="larger"
                      severity="info"
                      className="mt-0.5"
                    >
                      {CurrencyFormater(premiumData?.totalPremium)}{' '}
                    </Text>
                  </span>
                  <span>
                    <Text
                      severity="info"
                      className="cursor-pointer"
                      onClick={(_) => {
                        setShowViewBreakup(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Text>
                  </span>
                </div>
              ),
            }
          : null,
        {
          label: (
            <span className="text-primary">Proposal Status</span>
          ),
          text: (
            <div className="flex flex-col">
              {buyFirePolicy?.proposalStatus ? (
                <>
                  <Text>{buyFirePolicy?.proposalStatus}</Text>
                </>
              ) : (
                <Text severity="neutral-darker" className="mt-0.5">
                  Not Captured
                </Text>
              )}
            </div>
          ),
        },

        {
          text: (
            <Button
              flat={true}
              type={'button'}
              disabled={
                !buyFirePolicy?.proposalNumber?.length > 0 ||
                loadingDownload
              }
              size={'small'}
              className={
                !buyFirePolicy?.proposalNumber?.length > 0 ||
                loadingDownload
                  ? 'mt-4 h-8 border-neutral-darker text-neutral-darker hover:bg-neutral-darker focus:outline-none'
                  : 'mt-4 h-8'
              }
              onClick={async (_) => {
                try {
                  setAlerts([]);
                  setLoadingDownload(true);
                  let getDateTime = fetchQuery({
                    query: GET_DATE_TIME,
                  });
                  let { data: getDateTimeData } = await getDateTime;
                  let fireProposalPdfVariables = getBase64Var(
                    buyFirePolicy,
                    getDateTimeData,
                  );

                  let proposalPDFBase64String = mutateQuery({
                    mutation: DOWNLOAD_FIRE_PROPOSAL_PDF,
                    variables: fireProposalPdfVariables,
                  });

                  let {
                    data: dataBase64String,
                  } = await proposalPDFBase64String;

                  const {
                    firedownloadProposalForm,
                  } = dataBase64String;
                  const {
                    base64Pdf: downloadBase64String,
                  } = firedownloadProposalForm;
                  setLoadingDownload(false);

                  let byteCharacters = atob(
                    downloadBase64String.toString(),
                  );
                  let byteNumbers = new Array(byteCharacters.length);
                  for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                  }
                  let byteArray = new Uint8Array(byteNumbers);
                  let file = new Blob([byteArray], {
                    type: 'application/pdf;base64',
                  });
                  let fileURL = URL.createObjectURL(file);
                  window.open(fileURL);
                } catch (error) {
                  setAlerts([
                    {
                      id: Date.now(),
                      content: (
                        <div className="flex flex-col w-full h-full">
                          <Text type="normal">{error.message}</Text>
                        </div>
                      ),
                      type: 'error',
                      timeout: null,
                      disableClose: false,
                    },
                  ]);
                  setLoadingDownload(false);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}
            >
              <FontAwesomeIcon
                icon={loadingDownload ? faSpinner : faDownload}
                className="mr-4"
                spin={loadingDownload}
                size="lg"
              />
              {loadingDownload ? 'Downloading...' : 'Download Form'}
            </Button>
          ),
        },
      ].filter((d) => d),
    },
  ];

  let proposalSummaryDataiPadView = [
    {
      grid_data: [
        buyFirePolicy?.quoteNumber
          ? {
              label: (
                <div className="flex justify-start mt-2 mb-0.5">
                  <Text
                    type="label"
                    className="flex justify-end items-end h-full"
                  >
                    Quotation Number
                  </Text>
                  <Text className="text-secondary flex items-center">
                    <FontAwesomeIcon
                      icon={faExternalLinkAlt}
                      className="cursor-pointer ml-2 text-xs"
                      onClick={(_) =>
                        window.open(
                          `/uiquote/saved/${lobCode}/${
                            lobProductList?.find(
                              (lpl) =>
                                lpl?.lob_code?.toLowerCase() ===
                                lobCode?.toLowerCase(),
                            )?.lob_name
                          }/${productCode}/${productName}/${
                            buyFirePolicy?.quoteNumber
                          }`,
                        )
                      }
                    />
                  </Text>
                </div>
              ),
              colSpan: repeat,
              text: (
                <Link
                  to={`/uiquote/saved/${lobCode}/${
                    lobProductList?.find(
                      (lpl) =>
                        lpl?.lob_code?.toLowerCase() ===
                        lobCode?.toLowerCase(),
                    )?.lob_name
                  }/${productCode}/${productName}/${
                    buyFirePolicy?.quoteNumber
                  }`}
                >
                  <Text className="text-secondary underline">
                    {buyFirePolicy?.quoteNumber}
                  </Text>
                </Link>
              ),
            }
          : null,
        buyFirePolicy?.proposalNumber
          ? {
              label: (
                <span className="text-primary">Proposal Number</span>
              ),
              colSpan: repeat,
              text: <Text>{buyFirePolicy?.proposalNumber}</Text>,
            }
          : null,
        buyFirePolicy?.proposalStatus
          ? {
              label: (
                <span className="text-primary">Proposal Status</span>
              ),
              text: <Text>{buyFirePolicy?.proposalStatus}</Text>,
              colSpan: repeat,
            }
          : null,
        tenure?.value
          ? {
              label: <span className="text-primary">Tenure</span>,
              text: (
                <span>
                  {parseInt(tenure?.value) === 1 ? (
                    <Text>{tenure?.value} Year</Text>
                  ) : (
                    <Text>{tenure?.value} Years</Text>
                  )}
                </span>
              ),
              colSpan: repeat,
            }
          : null,
        premiumData
          ? {
              label: (
                <span className="text-primary">
                Total Premium (inclusive of all taxes)
                </span>
              ),
              colSpan: repeat,
              text: (
                <div className="flex justify-start space-x-2 mt-1">
                  <span>
                    <Text
                      type="larger"
                      severity="info"
                      className="mt-0.5"
                    >
                      {CurrencyFormater(premiumData?.totalPremium)}{' '}
                    </Text>
                  </span>
                  <span className="mt-2.5">
                    <Text
                      severity="action"
                      type="label"
                      className="quanta_link cursor-pointer mt-1"
                      onClick={(_) => {
                        setShowViewBreakup(true);
                      }}
                    >
                      View Breakup
                    </Text>
                  </span>
                </div>
              ),
            }
          : null,
        {
          text: (
            <span className="flex flex-col items-end justify-end py-3 w-full h-full">
              <Button
                flat={true}
                type={'button'}
                disabled={
                  !buyFirePolicy?.proposalNumber.length > 0 ||
                  loadingDownload
                }
                size="medium"
                className="w-full"
                onClick={async (_) => {
                  try {
                    setAlerts([]);
                    setLoadingDownload(true);
                    let getDateTime = fetchQuery({
                      query: GET_DATE_TIME,
                    });
                    let { data: getDateTimeData } = await getDateTime;
                    let fireProposalPdfVariables = getBase64Var(
                      buyFirePolicy,
                      getDateTimeData,
                    );

                    let proposalPDFBase64String = mutateQuery({
                      mutation: DOWNLOAD_FIRE_PROPOSAL_PDF,
                      variables: fireProposalPdfVariables,
                    });

                    let {
                      data: dataBase64String,
                    } = await proposalPDFBase64String;

                    const {
                      firedownloadProposalForm,
                    } = dataBase64String;
                    const {
                      base64Pdf: downloadBase64String,
                    } = firedownloadProposalForm;
                    setLoadingDownload(false);

                    let byteCharacters = atob(
                      downloadBase64String.toString(),
                    );
                    let byteNumbers = new Array(
                      byteCharacters.length,
                    );
                    for (let i = 0; i < byteCharacters.length; i++) {
                      byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    let byteArray = new Uint8Array(byteNumbers);
                    let file = new Blob([byteArray], {
                      type: 'application/pdf;base64',
                    });
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                  } catch (error) {
                    setAlerts([
                      {
                        id: Date.now(),
                        content: (
                          <div className="flex flex-col w-full h-full">
                            <Text type="normal">{error.message}</Text>
                          </div>
                        ),
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                    setLoadingDownload(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >
                <FontAwesomeIcon
                  icon={loadingDownload ? faSpinner : faDownload}
                  className="mr-4"
                  spin={loadingDownload}
                  size="lg"
                />
                {loadingDownload
                  ? 'Downloading...'
                  : 'Download Proposal Form'}
              </Button>
            </span>
          ),
          colSpan: repeat,
        },
      ].filter((d) => d),
    },
  ];
  return (
    <>
      {list_loading || loadingLobList || loadingBuyFirePolicy ? (
        <Loading />
      ) : error_list || errorLobList || errorBuyFirePolicy ? (
        <Error error={error_list || errorLobList} />
      ) : (
        <div>
          <DataGridGroup
            data={
              repeat === repeatForDesktop
                ? proposalSummaryDataDesktopView
                : repeat === repeatForMobile
                ? proposalSummaryDataMobileView
                : proposalSummaryDataiPadView
                ? proposalSummaryDataiPadView
                : null
            }
            repeat={repeat}
            textType="label"
            titleType="title"
            titleSeverity="info"
            className="w-full"
            gap={0}
            gapX={16}
            isSeparatorRequired={false}
            gapY={2}
            spaceY={2}
            nullData={() => (
              <Text className="opacity-40">Not Captured</Text>
            )}
          />
          <ModalViewBreakupFire
            {...{
              showViewBreakup,
              setShowViewBreakup,
              locationPremium: quoteData?.finalisedPremium,
              title: 'Premium Breakup for Quote',
              productName,
            }}
          />
          <div>
            <NotificationList {...{ items: alerts }} />
          </div>
        </div>
      )}
    </>
  );
}
